const MAX_GOOGLE_CHAR = 2000;
export const splitHtmlWithDOM = (html: string): string[] => {
    if (html.length <= MAX_GOOGLE_CHAR) {
        return [html.trim()];
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const body = doc.body;

    const chunks: string[] = [];
    let currentChunk = '';

    const appendChunk = (htmlPart: string) => {
        if ((currentChunk + htmlPart).length > MAX_GOOGLE_CHAR) {
            if (currentChunk) chunks.push(currentChunk);
            currentChunk = htmlPart;
        } else {
            currentChunk += htmlPart;
        }
    };

    Array.from(body.childNodes).forEach((node) => {
        const tempContainer = document.createElement('div');
        tempContainer.appendChild(node.cloneNode(true));
        const nodeHtml = tempContainer.innerHTML;

        appendChunk(nodeHtml);
    });

    if (currentChunk) chunks.push(currentChunk);

    return chunks;
};



export const splitTextIntoChunks = (text: string): string[] => {
    if (text.length <= MAX_GOOGLE_CHAR) {
        return [text.trim()];
    }

    const chunks: string[] = [];
    let currentChunk = '';

    const sentences = text.split(/(?<=[.?!])\s+|\n+/);

    for (const sentence of sentences) {
        if ((currentChunk + sentence).length > MAX_GOOGLE_CHAR) {
            if (currentChunk.length > 0) {
                chunks.push(currentChunk.trim());
                currentChunk = '';
            }

            if (sentence.length > MAX_GOOGLE_CHAR) {
                const words = sentence.split(' ');
                let wordChunk = '';
                for (const word of words) {
                    if ((wordChunk + word).length > MAX_GOOGLE_CHAR) {
                        chunks.push(wordChunk.trim());
                        wordChunk = '';
                    }
                    wordChunk += word + ' ';
                }
                if (wordChunk.length > 0) {
                    chunks.push(wordChunk.trim());
                }
            } else {
                currentChunk = sentence + ' ';
            }
        } else {
            currentChunk += sentence + ' ';
        }
    }

    if (currentChunk.trim().length > 0) {
        chunks.push(currentChunk.trim());
    }

    return chunks;
};

